// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__6FzD1","container":"styles_container__eKkzf","title":"styles_title__lLVUt","wrapper":"styles_wrapper__1MPnH","answer":"styles_answer__Y6KSo"};